module.exports = __webpack_public_path__ + "static/media/Oval.e7e9afc2.svg";